import * as yup from 'yup';

export interface IStepFeedbackInfo {
    shipmentId: string;
}

export const stepFeedbackInitialValues = {
    rating: 0,
    feedback: ''
};

export const stepFeedbackSchema = yup.object().shape({
    rating: yup.number()
      .min(1, "Select at least one star")
      .required("Rating required"),
    feedback: yup.string()
      // feedback is optional; no .required() here
  });